import { ACTION_CENTRE } from "./constants";

export const initState = {
  refreshCreateTaskModalModule: false,
  newTaskCreatedInModal: false,
};

const ActionCentreReducer = (state = initState, action) => {
  switch (action.type) {
    case ACTION_CENTRE:
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
};

export default ActionCentreReducer;
